import { DateTime } from 'luxon'

export default defineNuxtPlugin((nuxtApp) => {

    function formatDate(date) {
        if (!date) return ''
        // const options = { year: 'numeric', month: 'numeric', day: 'numeric' };        
        // return new Date(date).toLocaleDateString(undefined, options)

        const d = new Date(date);
        const formattedDate = d.toLocaleDateString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric'
        }).replace(/ /g, '-');

        return formattedDate;
    }

    function formatDateTime(date) {
        if (!date) return ''
        // const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
        // return new Date(date).toLocaleString(undefined, options)

        const d = new Date(date);
        const formattedDate = d.toLocaleDateString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' 
        }).replace(/ /g, '-').replace(/,-/g, ' ');

        return formattedDate;
    }
  
    function toRelative (date) {
        return DateTime.fromSQL(date).toRelative({ style: 'long' })
    }

    return { provide: { formatDate, formatDateTime, toRelative } }
  })
  